import styled from 'styled-components';

import { useCommon } from '../../context/CommonContext';
import { CustomersWithCustomElementsE } from '../../declarations/enums/common';
import { FontWeightT } from '../../declarations/interfaces/theme';

export type HeadingT = {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  size?: string;
  weight?: keyof FontWeightT;
  align?: string;
  children?: React.ReactNode;
  isUppercase?: boolean;
  color?: string;
  transform?: 'capitalize' | 'uppercase' | 'lowercase';
};

const Container = styled.h1<HeadingT>`
  ${({ theme, weight, align, size, level, isUppercase, color, transform }) => `
    
    ${align ? `text-align: ${align}` : ''};
    ${isUppercase ? `text-transform: uppercase;` : ''}
    ${transform ? `text-transform: ${transform};` : ''}
    ${color ? `color: ${color};` : ``}
    font-family: ${theme.headersFont.name};

    font-size: ${
      size
        ? size
        : (level === 1 && `${theme.fontSizes.largest}`) ||
          (level === 2 && `${theme.fontSizes.xLarge}`) ||
          (level === 3 && `${theme.fontSizes.large}`) ||
          (level === 4 && `${theme.fontSizes.medium}`) ||
          (level === 5 && `${theme.fontSizes.small}`)
    };

    font-weight: ${weight ? theme.fontWeights[weight] : theme.fontWeights['semibold']};
    line-height: 1;
  `}
`;

const Heading = styled((props: HeadingT) => {
  const { level = 1, children, isUppercase, color } = props;
  const {
    isMuralToTheme,
    slugUrl,
    calculatorThemeDto: { textColour, primaryColour },
  } = useCommon();

  //TODO Add ability to customize title color from admin panel, to avoid such complicated conditions
  const titleColor = color ? color : isMuralToTheme ? textColour : primaryColour;
  const sixsensesHeadingColor =
    CustomersWithCustomElementsE.SIX_SENSES_DOURO_VALLEY_SAMODAES === slugUrl && '#000';

  return (
    <Container
      as={`h${level}`}
      isUppercase={isUppercase || isMuralToTheme}
      color={sixsensesHeadingColor || titleColor}
      {...props}
    >
      {children}
    </Container>
  );
})``;

export default Heading;
